import { FC } from 'react';
import { useSelector, useDispatch } from 'dva';
import { Select } from 'iglooform';

const SwitchLang: FC<any> = (props) => {
  let { languages, currentLang } = useSelector<ReduxState, GlobalState>(
    (state) => state.global,
  );
  const dispatch = useDispatch();

  console.log('local storage', localStorage.getItem('selected_lang')?.length);

  currentLang = !localStorage.getItem('selected_lang')?.length
    ? 'vi-VN'
    : (localStorage.getItem('selected_lang') as string);
  console.log('switch lang: ', currentLang);

  const handleChange = (currentLang: string) => {
    localStorage.setItem(SELECTED_LANG, currentLang); // 将选中的语言存入storage，以便在刷新页面的时候仍然保留选中的语言
    dispatch({
      type: 'global/setData',
      payload: {
        cursor: '0', // earnings commission需要重新请求
        currentLang,
      },
    });
    location.reload();
  };

  return (
    <Select
      value={currentLang as string}
      {...props}
      size="small"
      onChange={handleChange}
    >
      {languages.map(({ title, key }) => (
        <Select.Option key={key} value={key}>
          {title}
        </Select.Option>
      ))}
    </Select>
  );
};

export default SwitchLang;
